import { render } from "./AgendamentosForm.vue?vue&type=template&id=00f1a901"
import script from "./AgendamentosForm.vue?vue&type=script&lang=js"
export * from "./AgendamentosForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__